import { render, staticRenderFns } from "./pkgGroup.vue?vue&type=template&id=768b7810&"
import script from "./pkgGroup.vue?vue&type=script&lang=js&"
export * from "./pkgGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports